import type { ProductInput, TechnicalPropertyInput } from "../product.types";

export const setTechnicalProperty = (
  property: TechnicalPropertyInput,
  input: ProductInput,
) => {
  if (!input?.state) {
    throw new Error("Input state is missing");
  }
  const propertyStates = input.state.propertyStates;
  if (!propertyStates) {
    throw new Error(
      "Cannot set technical property: propertyStates is undefined",
    );
  }
  let propertyFound = false;
  input.state?.propertyStates?.forEach((prop) => {
    if (prop && prop?.id && prop.id === property.id) {
      if (propertyFound) {
        throw new Error(
          `Duplicate property id found: ${property.id}. Each property id must be unique.`,
        );
      }
      prop.value = property.value;
      propertyFound = true;
    }
  });
  if (!propertyFound) {
    input.state.propertyStates = [...propertyStates, property];
  }
};
